module.exports = __webpack_public_path__ + "static/img/ATG-Logo-large.23123b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ATG-Logo-large.png
// module id = aTx6
// module chunks = 1